module.exports = __webpack_public_path__ + "1792395595471/images/fa-regular-400.ba2a91d.svg";